import {setElementCookies} from 'app/utils';
import {urlByLang} from 'app/utils/langs/urlByLang';
import {replaceLocale} from 'app/utils/langs/replaceLocale';
import {configStore} from 'app/store/global';

export const switchLanguage = (e: Event, lang: string): void => {
    const path = location.pathname;

    if (configStore.CURRENT_LOCALE === lang) {
        return;
    }
    location.pathname = configStore.CURRENT_LOCALE === configStore.DEFAULT_LOCALE
        ? `/${urlByLang(lang)}${path}`
        : replaceLocale(path, lang);
    setElementCookies('lang', lang);
    e && e.preventDefault();
};
